// extracted by mini-css-extract-plugin
export default {"container":"slider_container__KdEA0","last":"slider_last__fnszS","handle":"slider_handle__o-4Po"};